import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createRenamePersonaCommand } from '../../../api/commands/factory/createPersonaCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class UpdatePersonaName extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'UpdatePersonaName';

    public constructor(public id: string, public name: string) {
        super(UpdatePersonaName.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: UpdatePersonaName): Promise<boolean> => {
    return await useSendCommandAsync(action, {
        createCommand: async () => await createRenamePersonaCommand(action),
    });
};

const reducer = (state: StorymapState, action: UpdatePersonaName): void => {
    const persona = state.personas.find((x) => x.id === action.id);

    persona.name = action.name;
};

//@ts-ignore
registerMiddleware(UpdatePersonaName.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(UpdatePersonaName.ACTION_TYPE, reducer);
